
{
  "familyId": "TAA-WOORD-ANTONIEM",
  "questions": [
    {
      "id": "TAA-WOORD-ANTONIEM-001",
      "familyId": "TAA-WOORD-ANTONIEM",
      "module": "Taalbegrip",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "woordenschat",
      "subSkill": "woord_antoniem",
      "questionType": "multiple_choice",
      "question": "Wat is het antoniem (tegenovergestelde) van 'dapper'?",
      "options": ["laf", "moedig", "sterk", "slim"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wat is een antoniem?",
            "content": "Een antoniem is een woord met de tegenovergestelde betekenis. Voorbeeld: groot ↔ klein, warm ↔ koud. Zoek het woord dat het tegenovergestelde betekent van 'dapper'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "antoniem_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Laf' is het antoniem van 'dapper'. Dapper betekent moedig, zonder angst. Laf betekent bang, niet durven. Ze zijn elkaars tegenovergestelde. Onthoud: een antoniem is een woord met de tegenovergestelde betekenis.",
        "solutionSteps": [
          "Wat betekent 'dapper'? → moedig, zonder angst",
          "Wat is het tegenovergestelde? → bang, niet durven",
          "Welk woord past? → 'laf'",
          "Check: dapper ↔ laf = tegenovergestelden ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Laf' is het tegenovergestelde van 'dapper'.",
          "1": "Je dacht waarschijnlijk dat 'moedig' het tegenovergestelde is. Maar 'moedig' betekent hetzelfde als 'dapper' — het is een synoniem, geen antoniem. Onthoud: synoniem = zelfde betekenis, antoniem = tegenovergestelde betekenis.",
          "2": "Je dacht waarschijnlijk dat 'sterk' het tegenovergestelde is van 'dapper'. Maar 'sterk' gaat over kracht, terwijl 'dapper' over moed gaat. Het antoniem moet over hetzelfde onderwerp gaan. Onthoud: zoek een woord over hetzelfde thema.",
          "3": "Je dacht waarschijnlijk dat 'slim' het tegenovergestelde is van 'dapper'. Maar 'slim' gaat over intelligentie, terwijl 'dapper' over moed gaat. Het antoniem van 'dapper' is 'laf'. Onthoud: het antoniem moet over hetzelfde thema gaan."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.antoniem-synoniem-verward", "label": "Kiest synoniem i.p.v. antoniem (moedig)", "optionIndex": 1 },
          { "id": "taa.antoniem-ander-thema-sterk", "label": "Kiest woord van ander thema (sterk=kracht)", "optionIndex": 2 },
          { "id": "taa.antoniem-ander-thema-slim", "label": "Kiest woord van ander thema (slim=intelligentie)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-ANTONIEM-002",
      "familyId": "TAA-WOORD-ANTONIEM",
      "module": "Taalbegrip",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "woordenschat",
      "subSkill": "woord_antoniem",
      "questionType": "multiple_choice",
      "question": "Welk woord is GEEN antoniem van 'vrolijk'?",
      "options": ["blij", "somber", "treurig", "verdrietig"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Antoniem of synoniem?",
            "content": "Een antoniem = tegenovergestelde betekenis (groot ↔ klein). Een synoniem = zelfde betekenis (groot = enorm). Zoek het woord dat GEEN tegenovergestelde is van 'vrolijk'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "antoniem_vs_synoniem",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "'Blij' is GEEN antoniem van 'vrolijk' — het is juist een synoniem (het betekent hetzelfde). Somber, treurig en verdrietig zijn wél antoniemen (tegenovergestelden) van 'vrolijk'. Onthoud: lees de vraag goed — hier wordt gevraagd welk woord GEEN antoniem is.",
        "solutionSteps": [
          "Wat betekent 'vrolijk'? → blij, opgewekt",
          "Welke woorden zijn het tegenovergestelde? → somber, treurig, verdrietig",
          "Welk woord betekent hetzelfde? → 'blij' (synoniem)",
          "'Blij' is dus GEEN antoniem maar een synoniem"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Blij' is een synoniem van 'vrolijk' (zelfde betekenis), niet een antoniem (tegenovergestelde).",
          "1": "Je dacht waarschijnlijk dat 'somber' geen antoniem is. Maar 'somber' betekent neerslachtig — dat is het tegenovergestelde van 'vrolijk'. 'Somber' is wél een antoniem. Onthoud: de vraag zoekt het woord dat GEEN antoniem is.",
          "2": "Je dacht waarschijnlijk dat 'treurig' geen antoniem is. Maar 'treurig' betekent droevig — dat is het tegenovergestelde van 'vrolijk'. 'Treurig' is wél een antoniem. Onthoud: zoek het woord dat hetzelfde betekent als 'vrolijk'.",
          "3": "Je dacht waarschijnlijk dat 'verdrietig' geen antoniem is. Maar 'verdrietig' betekent bedroefd — dat is het tegenovergestelde van 'vrolijk'. 'Verdrietig' is wél een antoniem. Het woord dat GEEN antoniem is, is 'blij' (synoniem)."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.niet-vraag-somber", "label": "Leest GEEN-vraag verkeerd (kiest somber)", "optionIndex": 1 },
          { "id": "taa.niet-vraag-treurig", "label": "Leest GEEN-vraag verkeerd (kiest treurig)", "optionIndex": 2 },
          { "id": "taa.niet-vraag-verdrietig", "label": "Leest GEEN-vraag verkeerd (kiest verdrietig)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-ANTONIEM-003",
      "familyId": "TAA-WOORD-ANTONIEM",
      "module": "Taalbegrip",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "woordenschat",
      "subSkill": "woord_antoniem",
      "questionType": "multiple_choice",
      "question": "Wat is het antoniem van 'tijdelijk'?",
      "options": ["permanent", "kort", "snel", "langzaam"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Antoniem zoeken",
            "content": "Bedenk eerst wat het woord betekent. 'Tijdelijk' = voor een beperkte periode. Het tegenovergestelde is dan: voor altijd, blijvend = permanent.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "antoniem_abstract",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Permanent' is het antoniem van 'tijdelijk'. Tijdelijk betekent voor een beperkte tijd. Permanent betekent voor altijd, blijvend. Ze zijn elkaars tegenovergestelde. Onthoud: bedenk eerst wat het woord betekent, zoek dan het tegenovergestelde.",
        "solutionSteps": [
          "Wat betekent 'tijdelijk'? → voor een beperkte periode",
          "Wat is het tegenovergestelde? → voor altijd, blijvend",
          "Welk woord past? → 'permanent'",
          "Check: tijdelijk ↔ permanent = tegenovergestelden ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Permanent' (voor altijd) is het tegenovergestelde van 'tijdelijk' (voor beperkte tijd).",
          "1": "Je dacht waarschijnlijk dat 'kort' het tegenovergestelde is van 'tijdelijk'. Maar 'kort' beschrijft hoe lang iets duurt, niet of het eindig of oneindig is. Iets kan kort én tijdelijk zijn. Onthoud: het antoniem van 'tijdelijk' gaat over eindig vs. oneindig.",
          "2": "Je dacht waarschijnlijk dat 'snel' het tegenovergestelde is van 'tijdelijk'. Maar 'snel' gaat over snelheid, terwijl 'tijdelijk' over duur gaat. Het antoniem moet over hetzelfde thema gaan. Onthoud: zoek een woord over hetzelfde onderwerp.",
          "3": "Je dacht waarschijnlijk dat 'langzaam' het tegenovergestelde is van 'tijdelijk'. Maar 'langzaam' gaat over snelheid, terwijl 'tijdelijk' over duur gaat. Het antoniem van 'tijdelijk' is 'permanent'. Onthoud: duur ≠ snelheid."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.antoniem-ander-thema-kort", "label": "Verwart duur met lengte (kort)", "optionIndex": 1 },
          { "id": "taa.antoniem-ander-thema-snel", "label": "Verwart duur met snelheid (snel)", "optionIndex": 2 },
          { "id": "taa.antoniem-ander-thema-langzaam", "label": "Verwart duur met snelheid (langzaam)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-ANTONIEM-004",
      "familyId": "TAA-WOORD-ANTONIEM",
      "module": "Taalbegrip",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "woordenschat",
      "subSkill": "woord_antoniem",
      "questionType": "multiple_choice",
      "question": "Welk woordpaar zijn GEEN antoniemen?",
      "options": ["snel — vlug", "warm — koud", "groot — klein", "licht — donker"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Antoniemen herkennen",
            "content": "Antoniemen zijn woorden met een tegenovergestelde betekenis. Synoniemen zijn woorden met dezelfde betekenis. Zoek het paar dat GEEN tegenovergestelden zijn.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "antoniem_paar_herkennen",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Snel' en 'vlug' zijn synoniemen (ze betekenen hetzelfde), geen antoniemen. De andere paren zijn wél antoniemen: warm ↔ koud, groot ↔ klein, licht ↔ donker. Onthoud: synoniemen = zelfde betekenis, antoniemen = tegenovergestelde betekenis.",
        "solutionSteps": [
          "Controleer elk paar: zijn het tegenovergestelden?",
          "Snel — vlug: zelfde betekenis (synoniemen) → GEEN antoniemen ✗",
          "Warm — koud: tegenovergestelden ✓",
          "Groot — klein: tegenovergestelden ✓",
          "Licht — donker: tegenovergestelden ✓",
          "Antwoord: 'snel — vlug' zijn geen antoniemen"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Snel' en 'vlug' betekenen hetzelfde — het zijn synoniemen, geen antoniemen.",
          "1": "Je dacht waarschijnlijk dat 'warm — koud' geen antoniemen zijn. Maar warm en koud zijn juist het tegenovergestelde van elkaar — ze zijn wél antoniemen. Onthoud: het paar dat GEEN antoniemen is, is 'snel — vlug' (synoniemen).",
          "2": "Je dacht waarschijnlijk dat 'groot — klein' geen antoniemen zijn. Maar groot en klein zijn juist het tegenovergestelde van elkaar — ze zijn wél antoniemen. Onthoud: zoek het paar dat hetzelfde betekent.",
          "3": "Je dacht waarschijnlijk dat 'licht — donker' geen antoniemen zijn. Maar licht en donker zijn juist het tegenovergestelde van elkaar — ze zijn wél antoniemen. Onthoud: 'snel — vlug' zijn synoniemen (zelfde betekenis), niet antoniemen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.geen-antoniem-warm-koud", "label": "Denkt warm-koud geen antoniemen", "optionIndex": 1 },
          { "id": "taa.geen-antoniem-groot-klein", "label": "Denkt groot-klein geen antoniemen", "optionIndex": 2 },
          { "id": "taa.geen-antoniem-licht-donker", "label": "Denkt licht-donker geen antoniemen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-ANTONIEM-005",
      "familyId": "TAA-WOORD-ANTONIEM",
      "module": "Taalbegrip",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "woordenschat",
      "subSkill": "woord_antoniem",
      "questionType": "matching",
      "question": "Koppel elk woord aan zijn antoniem (tegenovergestelde).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "mooi", "right": "lelijk" },
          { "left": "hard", "right": "zacht" },
          { "left": "rijk", "right": "arm" },
          { "left": "dik", "right": "dun" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Antoniemen koppelen",
            "content": "Zoek bij elk woord het tegenovergestelde. Mooi ↔ lelijk, hard ↔ zacht, rijk ↔ arm, dik ↔ dun.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "antoniem_koppelen",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Mooi ↔ lelijk, hard ↔ zacht, rijk ↔ arm, dik ↔ dun. Dit zijn allemaal antoniemen: woorden met een tegenovergestelde betekenis. Onthoud: bij elk woord kun je het tegenovergestelde bedenken door te denken aan het andere uiterste.",
        "solutionSteps": [
          "Mooi → wat is het tegenovergestelde? → lelijk (uiterlijk)",
          "Hard → wat is het tegenovergestelde? → zacht (aanraking/geluid)",
          "Rijk → wat is het tegenovergestelde? → arm (bezit)",
          "Dik → wat is het tegenovergestelde? → dun (dikte)"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "TAA-WOORD-ANTONIEM-006",
      "familyId": "TAA-WOORD-ANTONIEM",
      "module": "Taalbegrip",
      "tier": 8,
      "levelCode": "B7+",
      "group": 7,
      "skill": "woordenschat",
      "subSkill": "woord_antoniem",
      "questionType": "categorize",
      "question": "Sorteer deze woordparen: zijn het antoniemen (tegenovergestelden) of synoniemen (zelfde betekenis)?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Antoniemen", "Synoniemen"],
        "items": [
          { "text": "groot — klein", "correctCategory": 0 },
          { "text": "blij — vrolijk", "correctCategory": 1 },
          { "text": "warm — koud", "correctCategory": 0 },
          { "text": "snel — vlug", "correctCategory": 1 },
          { "text": "dapper — laf", "correctCategory": 0 },
          { "text": "mooi — prachtig", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Antoniemen vs. synoniemen",
            "content": "Antoniemen = tegenovergestelde betekenis (groot ↔ klein). Synoniemen = zelfde betekenis (blij = vrolijk). Vraag jezelf: betekenen deze woorden hetzelfde of het tegenovergestelde?",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "antoniem_synoniem_categorize",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Antoniemen (tegenovergestelden): groot-klein, warm-koud, dapper-laf. Synoniemen (zelfde betekenis): blij-vrolijk, snel-vlug, mooi-prachtig. Tip: vraag jezelf af — betekenen de woorden hetzelfde of het tegenovergestelde?",
        "solutionSteps": [
          "Groot — klein: tegenovergestelden → antoniemen",
          "Blij — vrolijk: zelfde betekenis → synoniemen",
          "Warm — koud: tegenovergestelden → antoniemen",
          "Snel — vlug: zelfde betekenis → synoniemen",
          "Dapper — laf: tegenovergestelden → antoniemen",
          "Mooi — prachtig: zelfde betekenis → synoniemen"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}
